import { addCustomEventListener, unwrap } from './Utils';
import axios                              from 'axios';

export default class Toasts
{

    constructor()
    {

        if (
            typeof AsGlobalSettings === 'undefined'
            || typeof AsGlobalSettings.user === 'undefined'
            || typeof AsGlobalSettings.user.toasts === 'undefined'
            || AsGlobalSettings.user.toasts.length < 1
        )
        {


            return;
        }


        if ( typeof AsGlobalSettings.user.toasts === 'object' )
        {
            let toastsArray = [];

            for ( const [ key, value ] of Object.entries(AsGlobalSettings.user.toasts) )
            {
                toastsArray.push(value);
            }

            AsGlobalSettings.user.toasts = toastsArray;
        }

        this.toasts = AsGlobalSettings.user.toasts.map((el, i) => {

            let toast = {
                type          : el.type,
                message       : el.message,
                id            : el.id,
                created       : el.created,
                title         : el.title,
                theme_id      : el.theme_id,
                badge_id      : el.badge_id,
                image         : el.image,
                badge_name    : el.badge_name,
                badgeSubtitle : el?.badgeSubtitle ?? '',
                bottomMessage : el?.bottomMessage ?? '',
            };

            if ( typeof el.bg !== 'undefined' && el.bg !== '' )
            {
                toast.bg = el.bg;
            }

            return toast;
        });


        console.log('all toasts', this.toasts);

        this.injectModal();

        this.bindEvents();

        if ( this.toasts )
        {

            this.currentToast = this.toasts.shift();

            this.showModal(this.currentToast);
        }
    }


    injectModal()
    {


        let preMessagesHtml = '' +
            '<div class="bg">' +
            '     <div class="modal">' +
            '         <div class="modal-inner">' +
            '                 <div class="inner-bg" role="presentation"></div>' +
            '                 <div class="kids-bg" role="presentation"><div class="frame"></div></div>' +
            '                 <button type="button" class="btn btn-close btn-close-modal">' +
            '                    <span class="sr-only">Fermer</span>' +
            '                 </button>' +
            '                 <div class="modal-inner-inner">' +
            '                 </div>' +
            '        </div>' +
            '    </div>' +
            '</div>';


        const modalDiv = document.createElement('div');
        modalDiv.setAttribute('id', 'toasts-modal');
        modalDiv.classList.add('modal-container');
        modalDiv.innerHTML = preMessagesHtml;

        this.modal        = document.body.appendChild(modalDiv);
        this.modalContent = this.modal.querySelector('.modal-inner-inner');


    }

    showModal(toast)
    {

        let htmlOut = '';

        if ( typeof toast.title !== 'undefined' && toast.title !== '' )
        {
            htmlOut += '<div class="toast-title">' + toast.title + '</div>';
        }


        if ( typeof toast.message !== 'undefined' && toast.message !== '' )
        {
            htmlOut += '<div class="toast-message">' + toast.message + '</div>';
        }

        if ( typeof toast.badge_name !== 'undefined' && toast.badge_name !== '' )
        {
            htmlOut += '<div class="toast-badge-name">' + toast.badge_name + '</div>';
        }

        htmlOut += '<div class="badge complete">';
        htmlOut += '<div class="badge-container">';
        htmlOut += '<div class="badge-container-inner" style="background: ' + (toast?.bg ?? '#f5d9dc') + '">';
        if ( typeof toast.badgeSubtitle !== 'undefined' && toast.badgeSubtitle !== '' )
        {
            const subtitleClass = toast.badgeSubtitle.length > 5 ? 'more-than-5-chars' : '';

            htmlOut += '<div class="toast-subtitle-container badge-subtitle ' + subtitleClass + ' ">' + toast.badgeSubtitle + '</div>';
        }

        if ( typeof toast.image !== 'undefined' && toast.image !== '' )
        {
            htmlOut += '<div class="toast-image-container badge-image-container"><img class="toast-image" src="' + toast.image + '" alt=""></div>';
        }
        htmlOut += '</div>'; // toast.image

        htmlOut += '</div>'; // badge-container-inner
        htmlOut += '</div>'; // badge-container
        htmlOut += '</div>'; // badge


        if ( typeof toast.bottomMessage !== 'undefined' && toast.bottomMessage !== '' )
        {
            htmlOut += '<div class="toast-bottom-message-container">' + toast.bottomMessage + '</div>';
        }
        htmlOut += '</div>';


        this.modalContent.innerHTML = htmlOut;


        const maybeParagraphs = this.modalContent.querySelector('.toast-bottom-message-container p');
        // <p>s inside <a>s is a no-no and Firefox doesn't like it
        if ( maybeParagraphs )
        {
            unwrap(this.modalContent.querySelector('.toast-bottom-message-container p'));
        }

        this.modal.style.display = 'block';


        this.bindInnerLinks(this.modalContent);

        console.info('Showing Toast', toast, this.toasts);
    }

    async hideModal(event)
    {

        event.stopPropagation();

        this.modal.style.display = 'none';

        await this.markToastAsRead();


    }

    bindEvents()
    {


        const btnClose = document.querySelector('#toasts-modal .btn-close-modal');
        const modalBg  = document.querySelector('#toasts-modal > .bg');


        btnClose.addEventListener('click', this.hideModal.bind(this));
        modalBg.addEventListener('click', this.hideModal.bind(this));


        // addCustomEventListener( '#toasts-modal .btn-close-modal', 'click', async () =>
        // {
        //
        //     console.log('global click')
        //     await this.hideModal();
        //
        // } )
        //
        // document.addEventListener( 'click', async ( e ) =>
        // {
        //
        //     console.log('Document click', e.target, this.modalContent, this.modalContent.contains( e.target ))
        //     if ( !this.modalContent.contains( e.target ) )
        //     {
        //         await this.hideModal();
        //
        //     } else
        //     {
        //         return true;
        //     }
        // } )


    }


    bindInnerLinks(container)
    {


        const innerLinks = container.querySelectorAll('a');

        if ( innerLinks && innerLinks.length > 0 )
        {
            Array.from(innerLinks).forEach((link) => {

                link.addEventListener('click', async (e) => {
                    e.preventDefault();


                    let url = e.target?.href ?? false;
                    if ( url === '' || url === '#' )
                    {
                        url = false;
                    }

                    console.log('InnerLink clicked', e, url);

                    const markAsRead = await this.markToastAsRead(url);

                })
            });
        }
    }

    async markToastAsRead(navigateToUrl = false)
    {

        const currentToastType = this.currentToast?.type ?? 'unknown';
        const currentToastId   = this.currentToast?.id ?? 0;

        try
        {
            console.log('sending markToastAsRead',this.toasts, this.toasts.length, navigateToUrl)

            // console.log( 'Before marking as read' )
            let response = await axios.post(`/endpoints/toasts/${currentToastType}/${currentToastId}`);
            // console.log( 'After marking as read' )


            // the array still includes the one we sent out ...
            // if there any others, there would be that one AND at least another ... > 1
            if ( this.toasts.length > 0 && navigateToUrl === false )
            {
                this.currentToast = this.toasts.shift();
                this.showModal(this.currentToast);
            }
            else if ( navigateToUrl )
            {
                window.location.href = navigateToUrl;
            }
        } catch ( e )
        {
            console.error(e);
        }

    }

}
